import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import Tooltip from 'rc-tooltip';
import grey from '@material-ui/core/colors/grey';

const styles = theme => ({
  icon: {
    color: 'inherit',
    marginRight: 0
  },
  menuSection: {
  }
});

class MenuSection extends React.Component {
	constructor(props, context) {
    super(props, context);

    this.resizeUpdate = this.resizeUpdate.bind(this);

    this.state = {
      open: {},
      hoveredMenuItem: '',
      isMobile: false,
      tooltipText: ''
    };
	}

  componentDidMount() {
    this.resizeUpdate();
    window.addEventListener('resize', this.resizeUpdate);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeUpdate);
  }

  resizeUpdate() {
    this.setState({ isMobile: window.innerWidth <= 700 });
  }

  handleNestedListToggle(data) {
    var open = this.state.open;

    if (typeof open[data.n + '-' + data.parentN + '-' + data.lvl] === 'boolean'
      && open[data.n + '-' + data.parentN + '-' + data.lvl] === true){
       open[data.n + '-' + data.parentN + '-' + data.lvl] = false;

    } else {
       open[data.n + '-' + data.parentN + '-' + data.lvl] = true;
    }

    this.setState({open: open});
    return false;
  }

  handleClick(data) {
    this.props.clickItem(data, open[data.n + '-' + data.parentN + '-' + data.lvl]);
    this.setState({open: this.state.open});
  }

  isOpen(n, parentN, lvl) {
    if (typeof this.state.open[n +'-'+ parentN +'-'+ lvl] === 'boolean') {
      return this.state.open[n +'-'+ parentN +'-'+ lvl];

    } else {
      return false;
    }
  }

  keyDownEvent() {

    return;
  }

  onKeyUp() {

    return;
  }

  mouseEnterHandler(itemName) {
    this.setState({ hoveredMenuItem: itemName });
    return;
  }

  mouseLeaveHandler() {
    this.setState({ hoveredMenuItem: '' });
    return;
  }

  generateListItem(listitems, parentN, lvl, indexArrPrev) {
    if (!listitems) {
      return;
    }

    var classes = this.props.classes;
    const { isMobile, hoveredMenuItem } = this.state;

    if (typeof indexArrPrev === 'undefined') {
      var indexArrPrev = [];
    }

  	var n = 0;
  	//recursive
  	return (
      <List style={this.props.squeeze ? {padding: 0} : {}}>
        {listitems.map(function(item) {
          var indexArr = indexArrPrev.slice();
          indexArr.push(n);

          n++;

          var customStyle = {color: grey[200], fontSize: '0.85em', cursor: 'pointer', fontFamily: 'Pluto Sans Cond Bold'};

          if (this.props.squeeze) {
            customStyle['margin'] = '1px 0';
          }

          if (typeof item.style !== 'undefined') {
            customStyle = Object.assign(customStyle, item.style);
          }

          var customTextStyle = {color: '#fff', padding: '16px 3px 12px 3px', margin: '-11px 0'};
          if (item.active) {
            customStyle['backgroundColor'] = grey[200]; //'rgb(162, 162, 162)';
            customStyle['color'] = grey[700];
          }

          if (typeof item.textStyle !== 'undefined') {
            customTextStyle = Object.assign(customTextStyle, item.textStyle);
          }

          if (item.active) {
            customTextStyle['color'] = '#333';
          }

          if (typeof item.icon !== 'undefined'){
            var Icon = item.icon;
          }

          if (typeof item.secondIcon !== 'undefined'){
            var SecondIcon = item.secondIcon;
          }

          var iconStyle = {}
          if (item.color) {
            iconStyle.color = item.color;
            iconStyle.width = 14 + 'px';
            iconStyle.height = 14 + 'px';
            iconStyle.marginRight = 4 + 'px';
          }

          if (lvl > 0) customStyle['paddingLeft'] = (48 * lvl) - (item.icon ? 18 : 0) + 'px';

          if (typeof item.hide !== 'undefined' && item.hide) {
            return null;
          }

          var listItem = (
            <div>
              <ListItem
                onKeyDown={() => this.keyDownEvent()}
                onKeyUp={() => this.onKeyUp()}
                style={customStyle}
                disabled={item.disabled ? item.disabled : false}
                onMouseEnter={() => this.mouseEnterHandler(item.name)}
                onMouseLeave={() => this.mouseLeaveHandler()}
                >
                {Icon ? (<ListItemIcon className={classes.icon}><Icon style={iconStyle}/></ListItemIcon>) : ''}

                <ListItemText onClick={
                    this.handleClick.bind(this, {n, parentN, lvl, item, indexArr})
                  } style={customTextStyle} disableTypography={true} primary={item.name} />

                {item.secondIcon ? <SecondIcon className={classes.iconStyle} /> : ''}

                {this.isOpen(n, parentN, lvl) && typeof item.childs === 'object' ?
                  <ExpandLess className={classes.icon} onClick={this.handleNestedListToggle.bind(this, {n, parentN, lvl, item})} />
                  : ''}

                {!this.isOpen(n, parentN, lvl) && typeof item.childs === 'object' ?
                  <ExpandMore className={classes.icon} onClick={this.handleNestedListToggle.bind(this, {n, parentN, lvl, item})} />
                  : ''}
              </ListItem>

              {typeof item.childs === 'object' ?
                <Collapse in={this.isOpen(n, parentN, lvl)} timeout='auto' unmountOnExit>
                  {this.generateListItem(item.childs, n, lvl+1, indexArr)}
                </Collapse>
                : ''}
            </div>
          );

          if (item.tooltip) {
            return (
              <div key={(n)}>
                <Tooltip
                  overlayStyle={isMobile ? {display: 'none'} : {zIndex: 4, width: '350px'}}
                  trigger={['hover']}
                  placement='rightTop'
                  visible={item.name == hoveredMenuItem}
                  overlay={<span>{item.tooltip ? item.tooltipText : null}</span>}
                >
                    {listItem}
                </Tooltip>
                {item.element ? item.element : ''}
              </div>
            );

          } else {
            return (
              <div key={(n)}>
                {listItem}
                {item.element ? item.element : ''}
              </div>
            );
          }
        }.bind(this))}
      </List>
    );
  }

  render() {
    const { classes, menuItems } = this.props;

    return (
      <div className={classes.menuSection}>
        	{this.generateListItem(menuItems, 0, 0)}
      </div>
    );
  }
}

MenuSection.propTypes = {
  name: PropTypes.string,
  clickItem: PropTypes.func.isRequired,
  menuItems: PropTypes.array.isRequired,
  squeeze: PropTypes.bool
};

export default withStyles(styles)(MenuSection);



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/menu/menusection.js